import React from 'react';
import { Clock } from 'lucide-react';
import {
  calculateTripFreeTimeInBucket,
  calculateMultiloadGroupFreeTimeInBucket,
  formatFreeTimeMinutes,
  // formatFreeTimeClock, // used by disabled tooltip
} from '../utils/tripFreeTime';

/**
 * Wait / free-time strip above a trip or break card.
 * Never throws — if calc fails, renders nothing so the card still shows.
 * @param {boolean} [asMultiloadGroup] - treat trip as group P1 (Route header)
 * @param {object} [multiloadRoutes] - group_id → route steps (for prev group last dropoff)
 */
export default function TripFreeTimeBanner({
  trip,
  driverTrips = null,
  timezone = 'America/Los_Angeles',
  asMultiloadGroup = false,
  multiloadRoutes = null,
}) {
  let result = null;
  try {
    result = asMultiloadGroup
      ? calculateMultiloadGroupFreeTimeInBucket(
          trip,
          driverTrips,
          multiloadRoutes
        )
      : calculateTripFreeTimeInBucket(trip, driverTrips, multiloadRoutes);
  } catch {
    return null;
  }
  if (!result) return null;

  const label = formatFreeTimeMinutes(result.freeMinutes);
  // Tooltip disabled — keep helpers commented for easy restore
  // const est = formatFreeTimeClock(result.approxPickupTime, timezone);
  // const prev = formatFreeTimeClock(result.prevReadyTime, timezone);
  // const title = trip?.is_break
  //   ? `Free time: after prev ready ${prev} → break start ${est} (${label})`
  //   : `Free time: after prev ready ${prev} + ${Math.round(result.etaMinutes)}m travel → est. pickup ${est} (${label} wait)`;

  return (
    <div
      className="mb-0.5 flex items-center justify-center gap-2 rounded-md border border-teal-200/80 bg-teal-50 px-2 py-1.5 text-[10px] font-semibold tracking-wide text-teal-800"
      // title={title}
      aria-label={`${label} free`}
    >
      <Clock className="h-3.5 w-3.5 shrink-0 text-teal-600" strokeWidth={2.25} aria-hidden />
      <span className="tabular-nums">{label} free</span>
    </div>
  );
}
